import React from 'react'
import RegisterCom from '../Components/RegisterCom'
import Footer from '../Components/Footer'
const Register = () => {
  return (
    <div>
      <RegisterCom/>
      <Footer/>
    </div>
  )
}

export default Register